export const REVIEWS = "REVIEWS";
export const REVIEWS_LOADING = "REVIEWS_LOADING";
export const REVIEWS_HOME = "REVIEWS_HOME";
export const REVIEWS_HOME_LOADING = "REVIEWS_HOME_LOADING";
export const REVIEWS_LOAD_MORE = "REVIEWS_LOAD_MORE";
export const REVIEWS_LOAD_MORE_LOADING = "REVIEWS_LOAD_MORE_LOADING";
